module.exports = __webpack_public_path__ + "static/media/stmaryofangels.3733539b.webp";